<template>
  <div class="ai2-dialog">
    <!-- 图标 -->
    <div
      class="icon"
      v-if="showIcon"
      :style="{ bottom, right }"
      @mousedown="handleMouseDown"
      :class="{ dragging: isDragging }"
    >
      <img :src="icon" width="100%" height="100%" />
    </div>
    <!-- 对话框遮罩层 -->
    <!-- <transition name="fade">
      <div
        class="dialog-mask"
        v-if="!showIcon"
        @click="handleCloseDialog"
      ></div>
    </transition> -->
    <!-- 对话框 -->
    <transition name="slide-up">
      <div
        class="dialog"
        :class="{ 'full-screen': fullScreen, dragging: isDialogDragging }"
        :style="!fullScreen ? dialogPositionStyle : {}"
        v-if="!showIcon"
        @click.stop
      >
        <div class="dialog-content">
          <!-- 头部区域 -->
          <div
            class="dialog-header"
            :class="{ dragging: isDialogDragging }"
            @mousedown="handleDialogMouseDown"
          >
            <div class="header-title" @mousedown.stop>{{ aiName }}</div>
            <div class="header-actions">
              <div
                class="header-fullscreen"
                @click="handleFullScreen"
                @mousedown.stop
                :title="fullScreen ? '退出全屏' : '全屏'"
              >
                <i
                  :class="
                    fullScreen && false
                      ? 'el-icon-close'
                      : 'el-icon-full-screen'
                  "
                ></i>
              </div>
              <div
                class="header-close"
                @click="handleCloseDialog"
                @mousedown.stop
              >
                ×
              </div>
            </div>
          </div>
          <!-- 消息显示区 -->
          <div class="dialog-messages" ref="messagesContainer">
            <div
              v-for="(message, index) in messages"
              :key="index"
              :class="['message-item', message.type]"
            >
              <div class="message-bubble">
                <div
                  class="message-text"
                  v-if="!message.isLoading"
                  v-text="formatMessageContent(message.content)"
                ></div>
                <div class="message-loading" v-else>
                  AI正在思考中，请稍候
                  <span class="loading-dots">
                    <span class="dot">.</span>
                    <span class="dot">.</span>
                    <span class="dot">.</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 用户输入区 -->
          <div class="dialog-input">
            <div class="input-container">
              <textarea
                v-model="inputText"
                class="input-textarea"
                :class="{ disabled: isProcessing }"
                placeholder="输入消息..."
                :disabled="isProcessing"
                @keydown.enter.exact.prevent="handleSendMessage"
                @keydown.enter.shift.exact="handleShiftEnter"
                ref="textareaRef"
              ></textarea>
              <div
                class="send-button"
                :class="{ disabled: !inputText.trim() || isProcessing }"
                @click="handleSendMessage"
                :title="isProcessing ? '发送中...' : '发送消息'"
              >
                <i class="el-icon-s-promotion"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import icon from '@/assets/img/icon.jpg'

const aiName = '造价宝'

export default {
  name: 'AI2Dialog',
  data() {
    return {
      icon,
      bottom: '50px',
      right: '10px',
      showIcon: true,
      isDragging: false,
      hasMoved: false, // 标记是否发生了移动（用于区分点击和拖拽）
      dragStart: {
        x: 0,
        y: 0,
        bottom: 0,
        right: 0
      },
      // 对话框拖动相关
      isDialogDragging: false,
      dialogHasMoved: false,
      dialogPosition: {
        top: 'auto',
        left: 'auto',
        right: '80px',
        bottom: '0'
      },
      dialogDragStart: {
        x: 0,
        y: 0,
        top: 0,
        left: 0
      },
      aiName,
      messages: [
        {
          type: 'received',
          content: `你好！我是${aiName}，有什么可以帮助你的吗？`
        }
      ],
      inputText: '',
      isProcessing: false, // 标记是否正在处理中
      fullScreen: false // 全屏状态
    }
  },
  watch: {
    // 当消息列表变化时，自动滚动到底部
    messages: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      },
      deep: true
    },
    // 当对话框显示时，自动滚动到底部
    showIcon(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
    }
  },
  computed: {
    // 对话框位置样式
    dialogPositionStyle() {
      const style = {}
      if (this.dialogPosition.top !== 'auto') {
        style.top = this.dialogPosition.top + 'px'
        style.bottom = 'auto'
      } else {
        style.bottom = this.dialogPosition.bottom
      }
      if (this.dialogPosition.left !== 'auto') {
        style.left = this.dialogPosition.left + 'px'
        style.right = 'auto'
      } else {
        style.right = this.dialogPosition.right
      }
      return style
    }
  },
  mounted() {
    // 监听全局鼠标事件
    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleMouseUp)
  },
  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
  },
  methods: {
    // 将字符串像素值转换为数字
    parsePixelValue(value) {
      if (typeof value === 'string') {
        return parseFloat(value.replace('px', '')) || 0
      }
      return value || 0
    },
    // 鼠标按下事件
    handleMouseDown(e) {
      e.stopPropagation()

      this.isDragging = true
      this.hasMoved = false

      // 记录初始鼠标位置
      this.dragStart.x = e.clientX
      this.dragStart.y = e.clientY

      // 记录初始图标位置
      this.dragStart.bottom = this.parsePixelValue(this.bottom)
      this.dragStart.right = this.parsePixelValue(this.right)
    },
    // 鼠标移动事件
    handleMouseMove(e) {
      // 处理图标拖动
      if (this.isDragging) {
        // 计算鼠标移动的距离
        const deltaX = e.clientX - this.dragStart.x
        const deltaY = e.clientY - this.dragStart.y

        // 如果移动距离超过3px，认为是拖拽操作（降低阈值，更准确判断）
        if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
          this.hasMoved = true
          e.preventDefault()
        }

        // 只有在拖拽时才更新位置
        if (this.hasMoved) {
          // 计算新位置
          // right: 鼠标向右移动，right 减小（因为 right 是从右边向左的距离）
          // bottom: 鼠标向下移动，bottom 减小（因为 bottom 是从底部向上的距离）
          const newRight = this.dragStart.right - deltaX
          const newBottom = this.dragStart.bottom - deltaY

          // 获取窗口尺寸
          const windowWidth = window.innerWidth
          const windowHeight = window.innerHeight
          const iconWidth = 40 // 图标宽度
          const iconHeight = 40 // 图标高度

          // 边界限制，防止图标拖出视窗
          const minRight = 0
          const maxRight = windowWidth - iconWidth
          const minBottom = 0
          const maxBottom = windowHeight - iconHeight

          // 应用边界限制
          this.right = Math.max(minRight, Math.min(maxRight, newRight)) + 'px'
          this.bottom =
            Math.max(minBottom, Math.min(maxBottom, newBottom)) + 'px'
        }
      }

      // 处理对话框拖动
      if (this.isDialogDragging && !this.fullScreen) {
        const deltaX = e.clientX - this.dialogDragStart.x
        const deltaY = e.clientY - this.dialogDragStart.y

        // 如果移动距离超过3px，认为是拖拽操作
        if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
          this.dialogHasMoved = true
          e.preventDefault()
        }

        // 只有在拖拽时才更新位置
        if (this.dialogHasMoved) {
          // 计算新位置
          const newLeft = this.dialogDragStart.left + deltaX
          const newTop = this.dialogDragStart.top + deltaY

          // 获取窗口和对话框尺寸
          const windowWidth = window.innerWidth
          const windowHeight = window.innerHeight
          const dialogWidth = 300 // 对话框宽度
          const dialogHeight = 400 // 对话框高度

          // 边界限制，防止对话框拖出视窗
          const minLeft = 0
          const maxLeft = windowWidth - dialogWidth
          const minTop = 0
          const maxTop = windowHeight - dialogHeight

          // 应用边界限制并更新位置
          this.dialogPosition.left = Math.max(
            minLeft,
            Math.min(maxLeft, newLeft)
          )
          this.dialogPosition.top = Math.max(minTop, Math.min(maxTop, newTop))
          this.dialogPosition.right = 'auto'
          this.dialogPosition.bottom = 'auto'
        }
      }
    },
    // 鼠标释放事件
    handleMouseUp(e) {
      // 处理图标拖动结束
      if (this.isDragging) {
        const wasDragging = this.hasMoved
        this.isDragging = false
        this.hasMoved = false

        // 如果没有移动，说明是点击操作，打开对话框
        if (!wasDragging) {
          // 阻止后续的 click 事件
          e.preventDefault()
          e.stopPropagation()
          this.showIcon = false
        }
      }

      // 处理对话框拖动结束
      if (this.isDialogDragging) {
        this.isDialogDragging = false
        this.dialogHasMoved = false
      }
    },
    // 关闭对话框
    handleCloseDialog() {
      this.showIcon = true
    },
    // 发送消息
    handleSendMessage() {
      const text = this.inputText.trim()
      if (!text || this.isProcessing) return // 如果正在处理中，不允许发送

      // 设置处理中状态
      this.isProcessing = true

      // 添加用户消息
      this.messages.push({
        type: 'sent',
        content: text
      })

      // 清空输入框
      this.inputText = ''

      // 添加加载中的消息
      const messageId = Date.now() // 用于标识这条消息
      this.messages.push({
        type: 'received',
        content: '',
        isLoading: true,
        messageId: messageId
      })
      this.sendMessage(messageId, text)

      // 模拟AI回复（可以替换为实际的API调用）
      setTimeout(() => {}, 5000) // 5秒后返回结果
    },
    async sendMessage(messageId, message) {
      this.isProcessing = true
      const res = await this.$service.post('/api/mcp/ask', {
        systemPrompt: `你是一个工程造价软件的 AI 助手，名字叫造价宝，负责根据用户需求智能处理数据查询和回答。

## 核心职责

### 1. 数据库查询处理
当用户需求需要查询数据时：
- **唯一数据源**：使用 "valuation-mcp-stdio-server" MCP Server
- **库名限制**：所有查询必须且只能访问 "budget" 数据库
- **查询策略**：采用多轮多次查询方式
  - 优先查询主表："history_data_budget"
  - 关联子表："history_data_budget_bill"、"history_data_budget_indicator"、"history_data_budget_resource"
  - 根据查询结果反复迭代，直到获取完整数据
- **数据过滤**：自动过滤标记为删除的数据

### 2. 自主回答
当用户需求无需查询数据库时，根据已有知识直接回答。

## 安全约束（最高优先级）

### 信息脱敏要求
- **禁止暴露**：回答中不得出现任何数据库、计算机相关的技术术语
- **目的**：防止用户通过回答反查系统机密信息
- **替代表达**：使用业务语言而非技术语言描述数据

## 执行原则
1. 先判断是否需要查询数据库
2. 查询时严格遵守库名和数据表限制
3. 输出前进行安全审查，确保无技术敏感词
`,
        userPrompt: message
      })
      this.callbackMessage(messageId, res?.data ?? res?.message ?? '服务异常')
    },
    callbackMessage(messageId, message) {
      // 找到加载中的消息并替换
      const loadingIndex = this.messages.findIndex(
        msg => msg.isLoading && msg.messageId === messageId
      )
      if (loadingIndex !== -1) {
        // 替换为真实回复
        this.$set(this.messages, loadingIndex, {
          type: 'received',
          content: message
        })
      }
      // 处理完成，恢复输入框
      this.isProcessing = false
    },
    // Shift+Enter 换行
    handleShiftEnter() {
      // 找到加载中的消息并替换
    },
    // 滚动到底部
    scrollToBottom() {
      const container = this.$refs.messagesContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },
    // 格式化消息内容，去除首尾空白行
    formatMessageContent(content) {
      if (!content) return ''
      // 去除首尾的空白字符和换行符，但保留中间的换行
      return content.replace(/^[\s\n\r]+|[\s\n\r]+$/g, '')
    },
    // 全屏切换
    handleFullScreen() {
      this.fullScreen = !this.fullScreen
    },
    // 对话框拖动开始
    handleDialogMouseDown(e) {
      // 全屏模式下不允许拖动
      if (this.fullScreen) return

      e.stopPropagation()

      this.isDialogDragging = true
      this.dialogHasMoved = false

      // 记录初始鼠标位置
      this.dialogDragStart.x = e.clientX
      this.dialogDragStart.y = e.clientY

      // 获取对话框当前位置
      const dialogElement = e.currentTarget.parentElement.parentElement
      const rect = dialogElement.getBoundingClientRect()

      // 立即切换到left/top定位模式，避免位置跳跃
      if (this.dialogPosition.left === 'auto') {
        this.dialogPosition.left = rect.left
        this.dialogPosition.right = 'auto'
      }

      if (this.dialogPosition.top === 'auto') {
        this.dialogPosition.top = rect.top
        this.dialogPosition.bottom = 'auto'
      }

      // 记录初始对话框位置（现在都是left/top模式了）
      this.dialogDragStart.left = this.dialogPosition.left
      this.dialogDragStart.top = this.dialogPosition.top
    }
  }
}
</script>

<style scoped lang="less">
.ai2-dialog {
  z-index: 2300;

  .icon {
    position: fixed;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    transition: transform 0.1s ease-out;

    &:hover {
      transform: scale(1.1);
    }

    &.dragging {
      cursor: grabbing;
      transform: scale(1.15);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      z-index: 1006;
    }

    img {
      pointer-events: none;
    }
  }

  // 遮罩层
  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1007;
  }

  // 对话框
  .dialog {
    position: fixed;
    bottom: 0;
    right: 80px;
    width: 300px;
    height: 400px;
    background-color: #fff;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1008;
    overflow: hidden;
    transition: box-shadow 0.2s;

    &.dragging {
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
      z-index: 1009;
    }

    &.full-screen {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100% !important;
      height: 100% !important;
      border-radius: 0;
      z-index: 1888;

      .dialog-content {
        height: 100%;
        display: flex;
        flex-direction: column;
      }

      .dialog-messages {
        flex: 1;
        overflow-y: auto;
      }

      .input-textarea {
        min-height: 120px !important;
      }
    }

    .dialog-content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    // 头部区域
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 8px;
      border-bottom: 1px solid #e5e5e5;
      background-color: #f8f8f8;
      flex-shrink: 0;
      cursor: move;
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      transition: background-color 0.2s;

      &.dragging {
        background-color: #e8f4fd;
        cursor: grabbing;
      }

      .header-title {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        cursor: move;
        pointer-events: none; // 防止文字被选中，但允许事件冒泡
      }

      .header-actions {
        display: flex;
        align-items: center;
        gap: 4px;
        pointer-events: auto; // 确保按钮可以被点击
      }

      .header-fullscreen {
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        font-size: 16px;
        color: #999;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s;
        pointer-events: auto;

        &:hover {
          background-color: #e5e5e5;
          color: #333;
        }

        i {
          font-weight: 600;
          pointer-events: none;
        }
      }

      .header-close {
        width: 24px;
        height: 24px;
        line-height: 20px;
        text-align: center;
        font-size: 20px;
        color: #999;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s;
        pointer-events: auto;

        &:hover {
          background-color: #e5e5e5;
          color: #333;
        }
      }
    }

    // 消息显示区
    .dialog-messages {
      flex: 1;
      overflow-y: auto;
      padding: 6px 8px;
      background-color: #f5f5f5;
      display: flex;
      flex-direction: column;
      gap: 12px;

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 2px;

        &:hover {
          background: #999;
        }
      }

      .message-item {
        display: flex;
        width: 100%;

        &.received {
          justify-content: flex-start;

          .message-bubble {
            background-color: #fff;
            border-radius: 8px 8px 8px 0;
            max-width: 75%;
          }
        }

        &.sent {
          justify-content: flex-end;

          .message-bubble {
            background-color: #95ec69;
            border-radius: 8px 8px 0 8px;
            max-width: 75%;
          }
        }

        .message-bubble {
          padding: 4px 6px;
          word-wrap: break-word;
          word-break: break-all;

          .message-text {
            font-size: 13px;
            line-height: 1.5;
            color: #333;
            white-space: pre-wrap;
            word-wrap: break-word;
          }

          .message-loading {
            font-size: 13px;
            line-height: 1.5;
            color: #333;
            display: flex;
            align-items: center;

            .loading-dots {
              display: inline-flex;
              margin-left: 2px;

              .dot {
                display: inline-block;
                animation: dot-bounce 1.4s infinite ease-in-out;
                animation-fill-mode: both;

                &:nth-child(1) {
                  animation-delay: -0.32s;
                }

                &:nth-child(2) {
                  animation-delay: -0.16s;
                }

                &:nth-child(3) {
                  animation-delay: 0s;
                }
              }
            }
          }
        }
      }
    }

    // 用户输入区
    .dialog-input {
      padding: 6px 8px;
      border-top: 1px solid #e5e5e5;
      background-color: #fff;
      flex-shrink: 0;

      .input-container {
        position: relative;
        display: flex;
        align-items: flex-end;
      }

      .input-textarea {
        width: 100%;
        min-height: 60px;
        max-height: 120px;
        padding: 8px 40px 8px 8px; // 右侧留出按钮空间
        border: 1px solid #e5e5e5;
        border-radius: 6px;
        font-size: 13px;
        line-height: 1.5;
        resize: none;
        outline: none;
        box-sizing: border-box;
        font-family: inherit;
        transition: all 0.2s;

        &:focus {
          border-color: #95ec69;
        }

        &::placeholder {
          color: #999;
        }

        &.disabled,
        &:disabled {
          background-color: #f5f5f5;
          color: #999;
          cursor: not-allowed;
          border-color: #e5e5e5;

          &:focus {
            border-color: #e5e5e5;
          }
        }
      }

      .send-button {
        position: absolute;
        right: 6px;
        bottom: 6px;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #95ec69;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s;
        z-index: 10;

        i {
          font-size: 14px;
          color: #333;
          font-weight: 600;
        }

        &:hover:not(.disabled) {
          background-color: #7ed321;
          transform: scale(1.05);
        }

        &:active:not(.disabled) {
          transform: scale(0.95);
        }

        &.disabled {
          background-color: #e5e5e5;
          cursor: not-allowed;

          i {
            color: #999;
          }
        }
      }
    }
  }

  // 遮罩层淡入淡出动画
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  // 对话框从底部滑入动画
  .slide-up-enter-active {
    transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .slide-up-leave-active {
    transition: transform 0.3s cubic-bezier(0.55, 0.06, 0.68, 0.19);
  }

  .slide-up-enter,
  .slide-up-leave-to {
    transform: translateY(100%);
  }

  .slide-up-enter-to,
  .slide-up-leave {
    transform: translateY(0);
  }
}

// 加载动画
@keyframes dot-bounce {
  0%,
  80%,
  100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
